var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{attrs:{"alt":"Preview of Galaxy Workflow","src":_setup.src,"width":_setup.width,"height":"auto"}})
}
var staticRenderFns = []

export { render, staticRenderFns }